export var Z3kRoutes;
(function (Z3kRoutes) {
    Z3kRoutes["search"] = "search";
    Z3kRoutes["settings"] = "general-settings";
    Z3kRoutes["access"] = "shared-access";
    Z3kRoutes["sensors"] = "sensors";
    Z3kRoutes["temperature_sensors"] = "temperature-sensors";
    Z3kRoutes["guard_zones"] = "guard-zones";
    Z3kRoutes["guard_indicators"] = "guard-indicators";
    Z3kRoutes["buzzers"] = "buzzers";
    Z3kRoutes["notifications"] = "notifications";
    Z3kRoutes["users"] = "users-page";
    Z3kRoutes["output_actions"] = "output-actions";
    Z3kRoutes["radiomodules"] = "radiomodules";
    Z3kRoutes["fobs"] = "fobs";
    Z3kRoutes["radiorelays"] = "radiorelays";
    Z3kRoutes["managed_mechanisms"] = "executive-devices";
    Z3kRoutes["scenarios"] = "scenarios";
    Z3kRoutes["heating_circuits"] = "heating-circuits";
    Z3kRoutes["heating_modes"] = "heating-modes";
    //io_extensions = 'io-extensions',
    Z3kRoutes["web_elements"] = "web-elements";
    Z3kRoutes["service"] = "service";
    Z3kRoutes["ui"] = "user-ui";
    Z3kRoutes["modbus_devices"] = "modbus-devices";
    Z3kRoutes["z3k_config"] = "z3k-config";
    Z3kRoutes["radiosensors"] = "radiosensors";
    Z3kRoutes["interface_settings"] = "interface-settings";
    Z3kRoutes["main_settings"] = "settings";
    Z3kRoutes["history_z3k_config"] = "history-z3k-config";
    Z3kRoutes["mqtt_topics"] = "mqtt-mqtt_topics";
    Z3kRoutes["climatic_boilers"] = "climatic_boilers";
    Z3kRoutes["climatic_configuration"] = "climatic_configuration";
    Z3kRoutes["climatic_digital_sensors"] = "climatic_digital_sensors";
    Z3kRoutes["climatic_notifications"] = "climatic_notifications";
    Z3kRoutes["climatic_ntc_sensors"] = "climatic_ntc_sensors";
    Z3kRoutes["climatic_heating_circuits"] = "climatic_heating_circuits";
})(Z3kRoutes || (Z3kRoutes = {}));
export var Z3kSecondRoutes;
(function (Z3kSecondRoutes) {
    Z3kSecondRoutes["modbus_devices"] = "modbus-device";
    Z3kSecondRoutes["analog_inputs"] = "analog-input";
    Z3kSecondRoutes["zone"] = "zone";
    Z3kSecondRoutes["tm_keys"] = "tm-key";
    Z3kSecondRoutes["indicator"] = "indicator";
    Z3kSecondRoutes["buzzer"] = "buzzer";
    Z3kSecondRoutes["heating_circuit"] = "heating-circuit";
    Z3kSecondRoutes["boiler_groups"] = "boiler-group";
    Z3kSecondRoutes["boiler_cascades"] = "boiler-cascade";
    Z3kSecondRoutes["heating_modes"] = "heating-mode";
    Z3kSecondRoutes["boiler_modes"] = "boiler-mode";
    Z3kSecondRoutes["pumps"] = "pump";
    Z3kSecondRoutes["relay_controls"] = "relay-control";
    Z3kSecondRoutes["threeway_taps"] = "threeway-tap";
    Z3kSecondRoutes["boiler_adapters"] = "boiler-adapter";
    Z3kSecondRoutes["analog_outputs"] = "analog-output";
    Z3kSecondRoutes["notifications"] = "notification";
    Z3kSecondRoutes["output_actions"] = "output-action";
    Z3kSecondRoutes["radiomodules"] = "radiomodule";
    Z3kSecondRoutes["radiorelay"] = "radiorelay";
    Z3kSecondRoutes["radiosensor433"] = "radiosensor433";
    Z3kSecondRoutes["radiosensor868"] = "radiosensor868";
    Z3kSecondRoutes["radiofobs"] = "radio-fob";
    Z3kSecondRoutes["fob"] = "fob";
    Z3kSecondRoutes["scenarios"] = "scenario";
    Z3kSecondRoutes["users"] = "user";
    Z3kSecondRoutes["user_roles"] = "user-role";
    Z3kSecondRoutes["analog_temperature_sensors"] = "analog-temperature-sensor";
    Z3kSecondRoutes["wired_temperature_sensors"] = "wired-temperature-sensor";
    Z3kSecondRoutes["web_elements"] = "web-element";
    Z3kSecondRoutes["ui_groups"] = "ui-group";
    Z3kSecondRoutes["io_extensions"] = "io-extension";
    Z3kSecondRoutes["port_rs485"] = "port-rs485";
    Z3kSecondRoutes["heating_interface"] = "heating-interface";
    Z3kSecondRoutes["trusted_numbers"] = "trusted-number";
    Z3kSecondRoutes["ui_system_group"] = "ui-system-group";
    Z3kSecondRoutes["configuration"] = "configuration";
    Z3kSecondRoutes["device_maintenance"] = "device-maintenance";
    Z3kSecondRoutes["mqtt_topics"] = "mqtt-topic";
    Z3kSecondRoutes["mqtt_address"] = "mqtt-address";
    Z3kSecondRoutes["climatic_heating_circuit"] = "climatic-heating-circuit";
})(Z3kSecondRoutes || (Z3kSecondRoutes = {}));
export var Z3kAdditionsRoutes;
(function (Z3kAdditionsRoutes) {
    Z3kAdditionsRoutes["intervalweek"] = "intervalweek";
})(Z3kAdditionsRoutes || (Z3kAdditionsRoutes = {}));
export const RouteNaming = {
    [Z3kRoutes.settings]: 'Общие настройки',
    [Z3kRoutes.access]: 'Совместный доступ',
    [Z3kRoutes.users]: 'Пользователи',
    [Z3kRoutes.notifications]: 'Оповещения',
    [Z3kRoutes.service]: 'Сервис',
    [Z3kRoutes.interface_settings]: 'Настройки интерфейса',
    [Z3kRoutes.z3k_config]: 'Конфиг',
    [Z3kRoutes.history_z3k_config]: 'История конфигураций',
    [Z3kRoutes.heating_circuits]: 'Отопление',
    [Z3kRoutes.heating_modes]: 'Режимы отопления',
    [Z3kRoutes.temperature_sensors]: 'Датчики температуры',
    [Z3kRoutes.managed_mechanisms]: 'Исполнительные устройства',
    [Z3kRoutes.sensors]: 'Датчики',
    [Z3kRoutes.output_actions]: 'Действия с выходами',
    [Z3kRoutes.web_elements]: 'Элементы управления',
    [Z3kRoutes.ui]: 'Интерфейс пользователя',
    [Z3kRoutes.scenarios]: 'Сценарии',
    [Z3kRoutes.radiomodules]: 'Радиомодули',
    [Z3kRoutes.fobs]: 'Радиобрелоки',
    [Z3kRoutes.radiorelays]: 'Радиореле',
    [Z3kRoutes.radiosensors]: 'Радиодатчики',
    [Z3kRoutes.guard_zones]: 'Охранные зоны',
    [Z3kRoutes.guard_indicators]: 'Индикаторы охраны',
    [Z3kRoutes.buzzers]: 'Сирены',
    [Z3kRoutes.modbus_devices]: 'Устройства Modbus',
    [Z3kRoutes.search]: 'Поиск',
    [Z3kRoutes.main_settings]: 'Настройки',
    [Z3kRoutes.mqtt_topics]: 'MQTT',
    [Z3kRoutes.climatic_boilers]: 'Теплогенераторы',
    [Z3kRoutes.climatic_configuration]: 'Конфигурация',
    [Z3kRoutes.climatic_digital_sensors]: 'Цифровые термодатчики',
    [Z3kRoutes.climatic_notifications]: 'Оповещения',
    [Z3kRoutes.climatic_ntc_sensors]: 'Термодатчики NTC',
    [Z3kRoutes.climatic_heating_circuits]: 'Контуры отопления',
    [Z3kSecondRoutes.modbus_devices]: 'Устройства Modbus',
    [Z3kSecondRoutes.mqtt_topics]: 'Topics',
    [Z3kSecondRoutes.mqtt_address]: 'Настройки подключения',
    [Z3kSecondRoutes.analog_inputs]: 'Датчики',
    [Z3kSecondRoutes.zone]: 'Охранные зоны',
    [Z3kSecondRoutes.tm_keys]: 'Ключи TouchMemory',
    [Z3kSecondRoutes.indicator]: 'Индикаторы охраны',
    [Z3kSecondRoutes.buzzer]: 'Сирены',
    [Z3kSecondRoutes.heating_circuit]: 'Система отопления',
    [Z3kSecondRoutes.boiler_groups]: 'Группы котлов',
    [Z3kSecondRoutes.boiler_cascades]: 'Каскад котлов',
    [Z3kSecondRoutes.heating_modes]: 'Режимы отопления',
    [Z3kSecondRoutes.boiler_modes]: 'Котловые режимы',
    [Z3kSecondRoutes.pumps]: 'Насосы',
    [Z3kSecondRoutes.relay_controls]: 'Релейное управление',
    [Z3kSecondRoutes.threeway_taps]: 'Краны смесителей',
    [Z3kSecondRoutes.boiler_adapters]: 'Адаптеры котлов',
    [Z3kSecondRoutes.analog_outputs]: 'Аналоговые выходы',
    [Z3kSecondRoutes.notifications]: 'Оповещения',
    [Z3kSecondRoutes.output_actions]: 'Действия с выходами',
    [Z3kSecondRoutes.radiomodules]: 'Радиомодули',
    [Z3kSecondRoutes.radiorelay]: 'Радиореле',
    [Z3kSecondRoutes.radiosensor433]: 'Радиодатчики 433 МГц',
    [Z3kSecondRoutes.radiosensor868]: 'Радиодатчики 868 МГц',
    [Z3kSecondRoutes.radiofobs]: 'Брелоки 868 МГц',
    [Z3kSecondRoutes.fob]: 'Брелоки 433 МГц',
    [Z3kSecondRoutes.scenarios]: 'Сценарии',
    [Z3kSecondRoutes.users]: 'Пользователи',
    [Z3kSecondRoutes.user_roles]: 'Пользовательские роли',
    [Z3kSecondRoutes.analog_temperature_sensors]: 'Аналоговые датчики температуры',
    [Z3kSecondRoutes.wired_temperature_sensors]: 'Цифровые датчики температуры',
    [Z3kSecondRoutes.web_elements]: 'Элементы управления',
    [Z3kSecondRoutes.ui_groups]: 'Пользовательские вкладки',
    [Z3kSecondRoutes.io_extensions]: 'Устройства расширения',
    [Z3kSecondRoutes.port_rs485]: 'Настройка порта RS485',
    [Z3kSecondRoutes.heating_interface]: 'Интерфейс отопления',
    [Z3kSecondRoutes.trusted_numbers]: 'Доверенные номера',
    [Z3kSecondRoutes.ui_system_group]: 'Системные вкладки',
    [Z3kSecondRoutes.configuration]: 'Конфигурация устройства',
    [Z3kSecondRoutes.device_maintenance]: 'Обслуживание устройства',
    [Z3kSecondRoutes.climatic_heating_circuit]: 'Контуры отопления',
};
